<template>
  <v-card rounded="lg" elevation="7" class="card-hover transition-swing">
    <v-sheet
      class="d-flex align-center justify-center white--text font-weight-medium"
      height="80px"
      :color="color"
    >
      {{ title }}
    </v-sheet>

    <v-sheet height="120px" class="d-flex align-center justify-center">
      <div class="text-center">
        <iusa-logo no-link class="mb-2" />
        <br />
        <a v-if="url" :href="url" target="_blank" class="black--text">
          {{ text }}
        </a>
        <sales-policy-file-downloader
          v-else-if="policyType"
          class="mx-2"
          :policy-type="policyType"
          link-class="black--text"
          text
        />
      </div>
    </v-sheet>
  </v-card>
</template>

<script>
  import IusaLogo from '@/components/IusaLogo.vue';
  import SalesPolicyFileDownloader from '@/components/policies/SalesPolicyFileDownload.vue';

  export default {
    name: 'ResourceCard',

    components: {
      IusaLogo,
      SalesPolicyFileDownloader,
    },

    props: {
      title: {
        type: String,
        required: true,
      },
      text: {
        type: String,
        required: true,
      },
      url: {
        type: String,
        default: '',
      },
      policyType: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: '#db0218',
      },
    },
  };
</script>

<style scoped>
  .card-hover:hover {
    transform: translateY(-8px);
  }
</style>
